var _excluded = ["type", "editRenderer"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/require-default-props */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Ref, Table } from "../..";
import Form from "../Form";
import Modal from "../Modal";
import Date from "../Date/Date";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var AdvancedTableEditingCell = function AdvancedTableEditingCell(props) {
  var item = props.item,
    value = props.value,
    column = props.column,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onClick = props.onClick;
  var type = column.type,
    editRenderer = column.editRenderer,
    unFilteredRest = _objectWithoutPropertiesLoose(column, _excluded);
  var rest = _.omit(unFilteredRest, ['text', 'property']);
  var _React$useState = React.useState(),
    inputRef = _React$useState[0],
    setInputRef = _React$useState[1];
  var handleRef = function handleRef(node) {
    return setInputRef(node);
  };
  React.useEffect(function () {
    if (!_.isNil(inputRef)) {
      inputRef.firstChild.firstChild.firstChild.focus();
    }
  }, [inputRef]);
  var handleChange = React.useCallback(function (e, _ref) {
    var val = _ref.value;
    if (onChange) {
      onChange(item, column.property, val);
    }
  }, [item, column.property, onChange]);
  var render = React.useMemo(function () {
    return _.isFunction(editRenderer) && editRenderer(item, handleChange, onBlur);
  }, [editRenderer, item, onBlur, handleChange]);
  return (
    // on affiche le renderer du dev (modal popup ...)
    _.isFunction(editRenderer) ? /*#__PURE__*/_jsxs(Table.Cell, Object.assign({
      style: {
        padding: 0
      }
    }, render.type === Modal && {
      onClick: onClick
    }, rest, {
      children: [render.type === Modal && value, render]
    })) :
    /*#__PURE__*/
    // sinon on affiche la cell
    _jsx(Table.Cell, Object.assign({
      style: {
        padding: 0
      }
    }, rest, {
      children: type === 'date' ? /*#__PURE__*/_jsx(Ref, {
        innerRef: handleRef,
        children: /*#__PURE__*/_jsx(Date, {
          onBlur: handleChange,
          value: value
        })
      }) : /*#__PURE__*/_jsx(Ref, {
        innerRef: handleRef,
        children: /*#__PURE__*/_jsx(Form.Input, {
          fluid: true,
          value: value,
          onChange: handleChange,
          onBlur: onBlur
        })
      })
    }))
  );
};
AdvancedTableEditingCell.handledProps = ["column", "item", "onBlur", "onChange", "onClick", "value"];
AdvancedTableEditingCell.propTypes = {
  /**
     * Element à éditer
     */
  item: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
     * Valeur de l'input
     */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
     * Définition de la colonne
     */
  column: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
     * Callback au blur de l'input
     */
  onBlur: PropTypes.func,
  /**
     * Callback au changement de valeur
     */
  onChange: PropTypes.func,
  /**
     * Callback à la sélection d'une cellule
     */
  onClick: PropTypes.func
};
AdvancedTableEditingCell.defaultProps = {
  item: {},
  value: undefined,
  column: {},
  onBlur: null,
  onChange: null,
  onClick: null
};
export default AdvancedTableEditingCell;